/** Geometry needed to keep a selected page row visually pinned within its file branch. */
export interface SelectedPageVisualGeometry {
  currentVisualTop: number;
  currentOffset: number;
  selectedSlotTop: number;
  fileBottom: number;
  rowHeight: number;
}

/**
 * Returns a zero-flow translation for a selected page row.
 *
 * The row stays at its native position before crossing the selected-page slot, pins to that slot
 * while its file remains visible, and yields when the file's natural bottom reaches the row.
 */
export function calculateSelectedPageVisualOffset(geometry: SelectedPageVisualGeometry): number {
  const nativeRowTop = geometry.currentVisualTop - geometry.currentOffset;
  const lastAllowedTop = geometry.fileBottom - geometry.rowHeight;
  const targetTop = Math.max(nativeRowTop, Math.min(geometry.selectedSlotTop, lastAllowedTop));
  return Math.max(0, targetTop - nativeRowTop);
}
